module.exports = __webpack_public_path__ + "img/mp4.8a7d406a.svg";